import { TransferAPIType } from '@wetransfer/transfer/apollo-api/usage/types';
import {
  TRANSFER_TYPES,
  TRANSFER_TYPES_IDS,
  TransferTypeId,
} from '@wetransfer/transfer/transfer-bundle/constant/transfer-types';

export const getTransferType = (
  transfer:
    | {
        type?: TRANSFER_TYPES;
      }
    | {
        transfer_type?: TransferTypeId;
      }
    | TransferAPIType
): TRANSFER_TYPES | undefined => {
  if ('type' in transfer) {
    return transfer.type;
  }

  if ('transfer_type' in transfer) {
    return TRANSFER_TYPES_IDS[transfer.transfer_type];
  }

  return undefined;
};
